import {Injectable} from '@angular/core';
import {DashboardType} from 'src/app/shared/components/dynamic-dashboard/models/dashboards.model';

import {InsightsAnomaliesComponent} from '../components/insights-anomalies/insights-anomalies.component';
import {SingleWidget, WidgetType} from '../models/widget.model';
import {WidgetItem} from '../models/widget-item.model';
import {
  OrganizationTenantsComponent
} from "../../../../organizations/organization-tenants/organization-tenants.component";
import {TenantVenuesComponent} from "../../../../venues/components/tenant-venues/tenant-venues.component";
import {HierarchyMapComponent} from "../components/hierarchy-map/hierarchy-map.component";


@Injectable({
  providedIn: 'root'
})
export class LoadWidgetsService {
 
  orgWidgets: WidgetItem[] = [
    new WidgetItem(OrganizationTenantsComponent, new SingleWidget(WidgetType.TENANTS_HEALTH_GRID)),
    new WidgetItem(InsightsAnomaliesComponent, new SingleWidget(WidgetType.INSIGHTS_ANOMALIES)),
    new WidgetItem(HierarchyMapComponent, new SingleWidget(WidgetType.HIERARCHY_MAP))
  ];
  orgHealthWidgets: WidgetItem[] = [
    new WidgetItem(OrganizationTenantsComponent, new SingleWidget(WidgetType.TENANTS_HEALTH_GRID)),
    new WidgetItem(InsightsAnomaliesComponent, new SingleWidget(WidgetType.INSIGHTS_ANOMALIES)),
    new WidgetItem(HierarchyMapComponent, new SingleWidget(WidgetType.HIERARCHY_MAP)),
  ];
  orgTenantsWidgets: WidgetItem[] = [
    new WidgetItem(OrganizationTenantsComponent, new SingleWidget(WidgetType.TENANTS_HEALTH_GRID)),
  ];
  tenantWidgets: WidgetItem[] = [
    new WidgetItem(TenantVenuesComponent, new SingleWidget(WidgetType.VENUES_HEALTH_GRID)),
    new WidgetItem(InsightsAnomaliesComponent, new SingleWidget(WidgetType.INSIGHTS_ANOMALIES))
  ];
  tenantHealthWidgets: WidgetItem[] = [
    new WidgetItem(TenantVenuesComponent, new SingleWidget(WidgetType.VENUES_HEALTH_GRID)),
    new WidgetItem(InsightsAnomaliesComponent, new SingleWidget(WidgetType.INSIGHTS_ANOMALIES)),
    // new WidgetItem(kpisSelectorsChartComponent, new SingleWidget(WidgetType.CHART_WITH_SELECTORS)),
    //new WidgetItem(HealthChartComponent, new SingleWidget(WidgetType.HEALTH_CHART)),
    // new WidgetItem(ActionsPieComponent, new SingleWidget(WidgetType.ACTIONS_PIE)),
    // new WidgetItem(OrgHealthGridComponent, new SingleWidget(WidgetType.TENANTS_HEALTH_GRID)),
    //new WidgetItem(TrafficChartComponent, new SingleWidget(WidgetType.TRAFFIC_CHART)),
  ];
  devicesHealthWidgets: WidgetItem[] = [
    new WidgetItem(InsightsAnomaliesComponent, new SingleWidget(WidgetType.INSIGHTS_ANOMALIES)),
    // new WidgetItem(ActionsPieComponent, new SingleWidget(WidgetType.ACTIONS_PIE)),
    // new WidgetItem(kpisSelectorsChartComponent, new SingleWidget(WidgetType.CHART_WITH_SELECTORS))
  ];

  orgReports: WidgetItem[] = [
  ]
  tenantsReports: WidgetItem[] = [

  ]
  venueReports: WidgetItem[] = [


  ]
  deviceReports: WidgetItem[] = [


  ]

  constructor() {
  }

  /**
   * Return all the widget items for each dashboard type
   */
  getWidgetsItems(currentDashboard: DashboardType): WidgetItem[] {
    switch (currentDashboard) {
      case DashboardType.DEVICES_HEALTH_DASHBOARD:
        return this.devicesHealthWidgets;
      case DashboardType.ORG_REPORTS:
        return this.orgReports;
      case DashboardType.TENANT_REPORTS:
        return this.tenantsReports;
      case DashboardType.VENUE_REPORTS:
        return this.venueReports;
      case DashboardType.DEVICE_REPORTS:
        return this.deviceReports;
      default:
        break;
    }
  }

  /**
   * Return the data for each widget item
   * Main purpose: Get the full optional widgets list for each dashboard
   */
  getCurrentDashboardFullWidgetsList(currentDashboard: DashboardType): SingleWidget[] {
    let dashboardItems = this.getWidgetsItems(currentDashboard);
    return dashboardItems.map(item => item.data);
  }

  /**
   * Return only default widgets for current dashboard
   * @private
   */
  getCurrentDashboardDefaultWidgetsList(originalWidgetsArray: SingleWidget[], currentDashboard: DashboardType) {

    return [...originalWidgetsArray];
  }
}
